import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie"
import axios from "axios";
import "./style.css"

function Dashboard () {

  const [ gymMembers, setGymMembers ] = useState(0)
  const [ gymIncome, setGymIncome ] = useState(0)


  useEffect(() => {
    // Gym Members
    axios.get('https://buckinghammall-gym-api.eddyspace.com/api/users')
    .then(response => {
        console.log('Response:', response.data);
        setGymMembers(response.data.length)

        const resInc = (response.data)
        .map(item => {
          if (item.subscription_type === 'daily') {
            return 1500;
          }else if (item.subscription_type === 'monthly') {
            return 10000;
          } else if (item.subscription_type === 'quarterly') {
            return 20000;
          } else if (item.subscription_type === 'annually') {
            return 50000;
          } else {
            return 0; // Handle any other cases here if needed
          }
        })
        .reduce((acc, value) => acc + value, 0);
        console.log(resInc)
        setGymIncome(resInc.toFixed(2))
    })
    .catch(error => {
        console.error('Error:', error);
    });






  }, [])


    const cookies = new Cookies()
    // Function to get the session token from the cookie
    const getSessionUser = () => {
      return cookies.get('username');
    };

    const sessionUser = getSessionUser()
  

    return(
        <>
    <main>
        <div className="main__container">

          <div className="main__title">
            <img src="assets/hello.svg" alt="" />
            <div className="main__greeting">
              <h1>Hello Buckingham Mall ({sessionUser})</h1>
              <p>Welcome to your Gym dashboard</p>
            </div>
          </div>


          <div className="main__cards">
            <div className="card">
              <i
                className="fa fa-user-o fa-2x text-lightblue"
                aria-hidden="true"
              ></i>
              <div className="card_inner">
                <p className="text-primary-p"></p>
                <span className="font-bold text-title"></span>
              </div>
            </div>

            <div className="card">
              <i className="fa fa-calendar fa-2x text-red" aria-hidden="true"></i>
              <div className="card_inner">
                <p className="text-primary-p">Number of Gym Members</p>
                <span className="font-bold text-title">{gymMembers}</span>
              </div>
            </div>

            <div className="card">
              <i
                className="fa fa-video-camera fa-2x text-yellow"
                aria-hidden="true"
              ></i>
              <div className="card_inner">
                <p className="text-primary-p"></p>
                <span className="font-bold text-title"></span>
              </div>
            </div>

            <div className="card">
              <i
                className="fa fa-thumbs-up fa-2x text-green"
                aria-hidden="true"
              ></i>
              <div className="card_inner">
                <p className="text-primary-p"></p>
                <span className="font-bold text-title"></span>
              </div>
            </div>
          </div>

          <div className="charts">
            <div className="charts__left">
              <div className="charts__left__title">
                <div>
                  <h1>Daily Reports</h1>
                  <p>2, Kofesu, Abeokuta</p>
                </div>
                <i className="fa fa-usd" aria-hidden="true"></i>
              </div>
              <div id="apex1"></div>
            </div>

            <div className="charts__right">
              <div className="charts__right__title">
                <div>
                  <h1>Stats Reports</h1>
                  <p>2, Kofesu, Abeokuta</p>
                </div>
                <i className="fa fa-usd" aria-hidden="true"></i>
              </div>

              <div className="charts__right__cards">
                <div className="card1">
                  <h1></h1>
                  <p>₦</p>
                </div>

                <div className="card2">
                  <h1>Sales</h1>
                  <p>₦</p>
                </div>

                <div className="card3">
                  <h1>Users</h1>
                  <p>{gymMembers}</p>
                </div>

                <div className="card4">
                  <h1>Orders</h1>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
        </>
    )
}

export default Dashboard